import { Row } from '@tanstack/react-table'

import { DomainAlerts } from 'features/inventory/domain'
import { Domain } from 'features/inventory/types/domain'
import { Workspace } from 'features/workspace/types/workspace'
import WorkspaceAlerts from '../../WorkspaceAlerts'
import { WorkspaceDomainAlerts } from '../hooks/useGetFreshWorkspaceDomainAlerts'
import { WorkspaceForTable } from '../types'
import { isWorkspaceRow } from './utils'

type Props = Row<WorkspaceForTable> & {
  workspaceDomainAlerts: WorkspaceDomainAlerts[]
}

export const AlertsCell = ({
  depth,
  getParentRow,
  original: { alerts, id },
  workspaceDomainAlerts,
}: Props) => {
  if (isWorkspaceRow(depth)) {
    const freshWorkspaceAlerts: undefined | Workspace['alerts'] = workspaceDomainAlerts.find(
      ({ id: workspaceId }): boolean => workspaceId === id,
    )?.alerts

    return <WorkspaceAlerts alerts={freshWorkspaceAlerts || alerts} />
  } else {
    const freshDomainAlerts: Domain['alerts'] | undefined = workspaceDomainAlerts
      .find(({ id }): boolean => getParentRow()?.original.id === id)
      ?.domains.find(({ id: domainId }): boolean => domainId === id)?.alerts

    return <DomainAlerts alerts={freshDomainAlerts || (alerts as unknown as Domain['alerts'])} />
  }
}
